import AdminPanelPage from '../../pages/admin/panel.f7.html';
import CarPricingDashboardPage from '../../pages/admin/car-pricing/dashboard.f7.html';
import CarPricingEditPage from '../../pages/admin/car-pricing/edit.f7.html';
import CarLoanListPage from '../../pages/admin/car-loan/list.f7.html';
import CarBuyoutDepositDashboardPage from '../../pages/admin/car-buyout-deposit/dashboard.f7.html';
import CarBuyoutDepositEditPage from '../../pages/admin/car-buyout-deposit/edit.f7.html';
import CarLoanIssueDashboardPage from '../../pages/admin/car-loan-issue/dashboard.f7.html';
import CarLoanIssueEditPage from '../../pages/admin/car-loan-issue/edit.f7.html';

import Check from '../controllers/check';

const admin = [
  {
    name: 'admin-panel',
    path: '/admin-panel/',
    component: AdminPanelPage,
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'car-pricing-dashboard',
    path: '/car-pricing-dashboard/',
    component: CarPricingDashboardPage,
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'car-pricing-edit',
    path: '/car-pricing-edit/',
    popup: {
      component: CarPricingEditPage,
    },
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'car-loan-list',
    path: '/car-loan-list/',
    component: CarLoanListPage,
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'car-buyout-deposit-dashboard',
    path: '/car-buyout-deposit-dashboard/',
    component: CarBuyoutDepositDashboardPage,
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'car-buyout-deposit-edit',
    path: '/car-buyout-deposit-edit/',
    popup: {
      component: CarBuyoutDepositEditPage,
    },
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'car-loan-issue-dashboard',
    path: '/car-loan-issue-dashboard/',
    component: CarLoanIssueDashboardPage,
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
  {
    name: 'car-loan-issue-edit',
    path: '/car-loan-issue-edit/',
    popup: {
      component: CarLoanIssueEditPage,
    },
    allowedRoles: [1],
    beforeEnter: [Check.authorization, Check.permission],
  },
];

export default admin;
